import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { DLocalValidationError } from '#src/app/shared/types/payment';

export function useDLocalTranslateFieldError(): (field: keyof DLocalValidationError) => string | undefined {
	const { translate } = useI18n();

	return useCallback(
		(field: keyof DLocalValidationError): string | undefined => {
			switch (field) {
				case 'card':
					return translate('corgi.payments.dlocal.errors.incorrect_card_number');
				case 'cvv':
					return translate('corgi.payments.dlocal.errors.incorrect_cvc');
				case 'expire':
					return translate('corgi.payments.dlocal.errors.incorrect_expiry');
				default:
					return undefined;
			}
		},
		[translate],
	);
}
